// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import ProgramModificationChangeRequestDTO from './ProgramModificationChangeRequestDTO';
import GenderDTO from './GenderDTO';
import RacialEthnicGroupDTO from './RacialEthnicGroupDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface ProgramModificationAdvisoryBoardContactDTO extends EntitySelectorDTO { 
	id: string | null;
	programModificationChangeRequestId: string | null;
	programModificationChangeRequest: ProgramModificationChangeRequestDTO | null;
	firstName: string | null;
	lastName: string | null;
	genderId: number | null | null;
	gender: GenderDTO | null;
	employer: string | null;
	position: string | null;
	disability: boolean | null | null;
	organizedLabor: boolean | null | null;
	ethnicGroupId: number | null | null;
	ethnicGroup: RacialEthnicGroupDTO | null;
}

const ProgramModificationAdvisoryBoardContactDTO = {
    className: 'ProgramModificationAdvisoryBoardContactDTO',
    create: (initValues?: Partial<ProgramModificationAdvisoryBoardContactDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: '00000000-0000-0000-0000-000000000000',
			programModificationChangeRequestId: '00000000-0000-0000-0000-000000000000',
			programModificationChangeRequest: null,
			firstName: "",
			lastName: "",
			genderId: null,
			gender: null,
			employer: "",
			position: "",
			disability: null,
			organizedLabor: null,
			ethnicGroupId: null,
			ethnicGroup: null,
        },
        initValues);
    },
	id: 'id',
	programModificationChangeRequestId: 'programModificationChangeRequestId',
	programModificationChangeRequest: 'programModificationChangeRequest',
	firstName: 'firstName',
	lastName: 'lastName',
	genderId: 'genderId',
	gender: 'gender',
	employer: 'employer',
	position: 'position',
	disability: 'disability',
	organizedLabor: 'organizedLabor',
	ethnicGroupId: 'ethnicGroupId',
	ethnicGroup: 'ethnicGroup',
};

export default ProgramModificationAdvisoryBoardContactDTO;